import styled from "styled-components";
import {
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const FullWidthBannerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 70px;
`;

export const Banner = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	padding: 100px 0px 80px;
	p {
		margin: 0px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 60px 0px;
	}
`;

export const Header = styled.h1`
	width: 540px;
	font-size: 36px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 42.19px;
	text-align: center;
	margin: 0px;
	color: ${(props) => props.fontColor || COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 245px;
		font-size: 26px;
		line-height: 36px;
	}
`;

export const Description = styled.span`
	width: 514px;
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	text-align: center;
	margin-top: 25px;
	line-height: 26px;
	color: ${(props) => props.fontColor || COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 275px;
		font-size: 16px;
		line-height: 26px;
		margin-top: 20px;
	}
`;
